import React, {useState, useEffect} from 'react';
import useFetchData from '../../crud/useFetchData';
import {proto,url} from '../../Helpers/api';
import {get,sortBy} from 'lodash-es';
import {formataMoeda} from '../../Helpers/money';
import styled, {css} from 'styled-components';
import Typography from '@material-ui/core/Typography';
import Seletor from '../Seletor';
import {mesesExtenso} from '../../Helpers/date';
import {
  FormControl,
  // FormControlLabel,
  InputLabel,
  Select,
  Button,
  // Switch,
  MenuItem,
  Card,
} from '@material-ui/core';
import Grafico1 from './Grafico1';
import {getColor} from '../../Common/Cores'

let x = getColor()
let setCor = () => x.next().value


const Cont = styled.div`
  padding-left: 12px;
`
const LayoutItem = styled.div`
  flex: 1 1 auto;
  margin-right: 10px;
`

export function Header (props) {
  const { setAtiva, setEmpresa, empresa, empresas, mes, setMes, ano, setAno } = props;
  let empresaChange = x => { setAtiva(false); return setEmpresa(x) }
  const [ opt, setOpt ] = useState([]);
  useEffect(() => {
    setOpt(sortBy(empresas,'Apelido').map(e => {
      let label = e.Cidade ? ` - ${e.Cidade} ` : " "
      label = e.Apelido + label + `(${e.Codigo})`
      return { value: e.Codigo, label, sublabel: e.RazaoSocial }
    }).filter(e => e.value != 87)) //// REMOVE87)
  }, [empresas])
  return (
    <div style={{
      display: "flex",
      marginBottom:"15px",
      justifyContent: "space-around",
      alignItems: "center",
    }}>
      <div>
        <Typography variant="display2">Relatório Contábil</Typography>
      </div>
      <div style={{
        flex: "0 0 450px",
        display: "flex",
        flexDirection: "column",
      }}>
        <Seletor
          fullWidth
          label={"Empresa"}
          onChange={empresaChange}
          value={empresa}
          placeholder="Selecione a empresa"
          suggestions={opt}
          />
          <div style={{
            marginTop: "6px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <LayoutItem>
            <FormControl style={{ width: "100%" }}>
              <InputLabel htmlFor="mes">Mês</InputLabel>
              <Select
                value={mes}
                onChange={e => { setAtiva(false); setMes(e.target.value);}}
                // inputProps={{
                //   name: 'mes',
                //   id: 'mes',
                // }}
              >
              {mesesExtenso.map((m,i) => (
                <MenuItem value={String(i+1)}>{m}</MenuItem>
              ))}
              </Select>
            </FormControl>
          </LayoutItem>
          <LayoutItem>
            <FormControl style={{ width: "100%" }}>
              <InputLabel htmlFor="ano">Ano</InputLabel>
              <Select
                value={ano}
                onChange={e => { setAtiva(false); setAno(e.target.value);}}
                inputProps={{
                  name: 'ano',
                  id: 'ano',
                }}
              >
              {["2018", "2017", "2016"].map((a,i) => (
                <MenuItem value={a}>{a}</MenuItem>
              ))}
              </Select>
            </FormControl>
          </LayoutItem>
          <LayoutItem>
        <Button 
          variant="contained"
          onClick={() => setAtiva(true)}
          style={{ width: "100%" }}
        >
          Ok
        </Button>
        </LayoutItem>
        </div>
      </div>
    </div>
  )
}


export function Content(props) {
  // const { empresa, mes, ano, params, expand, setExpand } = props;
  const { empresa, mes, ano, expand, setExpand, setConta } = props;
  if (!empresa || !mes || !ano) return null;
  let empresaId = empresa.value;
  let data={};
  const [ sel, setSel ] = useState([]);
  const graphProps = { sel, setSel }
  // let urlPrefix = "?" + Object.entries(params).map(([k,v]) => {
  //   return encodeURIComponent(k) + '=' + encodeURIComponent(v)
  // }).join('&');
  // const f = useFetchData(`${proto}://${url}/teste/dre/${empresaId}/${ano}/${mes}${urlPrefix}`)
  const f = useFetchData(`${proto}://${url}/teste/dre/${empresaId}/${ano}/${mes}`)
  if (get(f,"isFinished")) {
    data = get(f,"data",{});
  }
  if (get(f,"isLoading")) return <div>Carregando dados...</div>
  if (get(f,"error")) return <div>Erro ao carregar dados!</div>
  let { listaById, raizes } = data;
  if (!raizes || !raizes.length) return <div>Aguarde...</div>
    Object.keys(listaById).forEach(k => {
      listaById[k].Cor = setCor()
    })
  return (
    <>
      <div style={{
        flex: "2 0 auto"
      }}>
        {raizes.map((_id) => {
          return (
            <MostraConta
              expand={expand}
              setExpand={setExpand}
              setConta={setConta}
              key={_id} 
              lista={listaById}
              itemId={_id}
              nivel={0}
              {...graphProps}
            />
          )
        })}
      </div>
      <div style={{
        flex: "1 0 auto"
      }}>
        <Grafico1
          {...graphProps}
        />
      </div>
    </>

  )
}

const MostraConta = props => {
  const {
    lista,
    itemId,
    nivel,
    expand,
    setExpand,
    setConta,
    sel,
    setSel,
  } = props;
  if (!lista || !itemId ) return null;
  let item = get(lista, itemId);
  if (!item) return null;
  let Children = item.Children || [];
  let opened = get(expand,nivel) == itemId
  let fecha = () => setExpand(expand.slice(0,nivel))
  let abre = () => setExpand([
    ...expand.slice(0,nivel),
    itemId
  ])
  let selected = sel && (sel.Id === itemId)
  return (
    <Cont>
      <Card_ 
        onClick={opened ? fecha : abre} 
        selected={selected}
      >
        <Mascara>
          {item.ClasCta}
        </Mascara>
        <span>
          {item.NOME_CTA}
        </span>
        <Moeda valor={item.SALDOATU}>
          {formataMoeda(item.SALDOATU)}
        </Moeda>
        <Button
          onClick={()=>setConta(item)}
        >
          ***
        </Button>
        <Button onClick={e => {
          e.stopPropagation();
          setSel({
            Nome: item.NOME_CTA,
            Total: item.SALDOATU,
            Id: itemId,
            Children: Children.map(_id => {
              let o = get(lista, _id);
              if (!o) return null;
              let valor = (o.SALDOATU >= 0) ? o.SALDOATU : o.SALDOATU * -1
              return {
                Id: _id,
                nome: o.NOME_CTA,
                valor,
                Cor: o.Cor,
              }
            }).filter(o=>o)
          })
        }}>
          >>>
        </Button>
      </Card_>
      { opened && Children.map(_id => (
        <MostraConta
          key={_id}
          {...props}
          lista={lista}
          itemId={_id}
          nivel={nivel + 1}
          expand={expand}
          setExpand={setExpand}
        />
      ))}
    </Cont>
  )
}

const Card_ = styled(Card)`
  padding: 2px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  cursor: ${props => props.onClick ? "pointer" : "inherit"};
  ${props => props.selected && css`
    background-color: #c5cae9;
  `}
`
const Mascara = styled.span`
  font-size: 12px;
  color: grey;
  margin-left: 4px;
  margin-right: 10px;
`
const Moeda = styled.span`
  color: ${colorize};
  margin-left: 10px;
`

function colorize(props) {
  const { valor } = props;
  if (valor > 0) return "green";
  if (valor < 0) return "red";
  return "gray";
}